export default __webpack_public_path__ + "static/media/LOCKETGO_LOGO_RVB-Bleu.6dde3a9e.svg";